import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ServiceItemComponent } from './service-item.component';

@NgModule({
  declarations: [ ServiceItemComponent ],
  imports: [
    CommonModule,
    MatIconModule,
    FlexLayoutModule,
    TranslateModule.forChild()
  ],
  exports: [ ServiceItemComponent ]
})
export class ServiceItemModule { }
